import { Component, OnInit } from '@angular/core';
import {RestApiService} from '../rest-api.service';
import {Router} from '@angular/router';
import {MessageService} from '../message.service';

@Component({
  selector: 'app-token-app',
  templateUrl: './token-app.component.html',
  styleUrls: ['./token-app.component.css']
})
export class TokenAppComponent implements OnInit {

  clientId: any;
  loginName: any;
  cat1: string;
  cat2: string;
  cat3: string;
  private respObject: any;
  srcType: string;
  typeId1: string;

  constructor(private _rest: RestApiService, private route: Router, private messageService: MessageService) {
  }

  ngOnInit() {
    this.clientId = 9;
    this.loginName = '20111344';
    this.cat1 = 'APPS';
    this.cat2 = 'Suraksha 2.0';
    this.typeId1 = 'Service Request';
    this.cat3 = 'DOT NET';
    // this.srcType = 'panel';
    this.messageService.clearSession();
  }

  save() {
    this._rest.generateToken(this.clientId, this.loginName).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        const data = this.respObject.details;
        window.location.href = this.messageService.API_ROOT + '/#/ticket/dashboardL&TCITAPP?token='
            + data.token + '&clientId=' + this.clientId + '&name=' + data.loginName + '&cat1=' + this.cat1 +
            '&cat2=' + this.cat2 + '&ticket_type1=' + this.typeId1 +  '&cat3=' +
            this.cat3 + '&callback=https://ssc.larsentoubro.com/';
      } else {
        alert(this.respObject.errorMessage);
      }
    }, (err) => {
      // alert(this.messageService.SERVER_ERROR);
    });
  }

}
